import { render, staticRenderFns } from "./promoterList.vue?vue&type=template&id=b46d02a2&scoped=true&"
import script from "./promoterList.vue?vue&type=script&lang=js&"
export * from "./promoterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46d02a2",
  null
  
)

export default component.exports